import React from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

import { Button } from '@mui/material';

function ResponsiveDialog({ open, title, content, handleClose, handleConfirm, confirmationString, loading }) {
  return (
    <div>
      <Dialog open={open} onClose={handleClose} aria-labelledby='responsive-dialog-title'>
        <DialogTitle id='responsive-dialog-title'>{title}</DialogTitle>
        <DialogContent>
          <DialogContentText whiteSpace='pre'>{content}</DialogContentText>
        </DialogContent>
        <DialogActions>
          {handleConfirm ? (
            <>
              <Button onClick={handleConfirm} loading={loading} color='primary'>
                {confirmationString ?? 'Ok'}
              </Button>
              <Button onClick={handleClose} disabled={loading}>
                Cancelar
              </Button>
            </>
          ) : (
            <Button onClick={handleClose}>Ok</Button>
          )}
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default ResponsiveDialog;
